module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"label-in":"Página inicial","label-out":"Entrar","description-in":"Este álbum tem acesso restrito ou não existe.","description-out":"Este álbum tem acesso restrito ou não existe. Caso tenha acesso a ele, entre com sua conta","title":"Atenção"}}')
  delete Component.options._Ctor
}
